<template>
  <div class="list" @click="goDetail(item)">
    <div class="list-item">
      <span class="top-left"></span>
      <span class="top-right"></span>
      <div class="img-con">
        <img class="img" :src="'http://img13.360buyimg.com/n1/' + item.filePath[0]" alt="">
      </div>
      <div class="goods-item-border">
        <div class="text-con">
          <div class="list-title">{{ item.products[0].productTitle }}</div>

          <div class="btn-con">
            <div class="left">
              <span class="text">年货价:</span>
              <s class="text" v-if="item.products[0].originalPrice">原价:￥{{ item.products[0].originalPrice }}</s>
            </div>
            <div class="right">
              <div class="text">
                <span class="big">{{ sellPrice[0] }}</span><span class="small">.{{ sellPrice[1] }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { mapGetters} from 'vuex';
export default {
  props: {
    itemData: {
      required: true,
    }
  },
  data() {
    return {
      item: {},
    }
  },
  computed:{
    ...mapGetters([
      'Pcoin',//平台金币信息
    ]),
    sellPrice(){
      let p = this.item.products[0].sellPrice || 0;
      p = p.toFixed(2)
      let pArr = p.split('.')
      return pArr
    }
  },
  watch: {
    itemData: {
      handler(newData, oldData) {
        this.item = newData
      },
      deep:true,
      immediate: true
    },

  },
  created() {

  },
  methods: {
    // 跳转至商品详情
    goDetail(item) {
      this.$router.push({name: 'jdGoodsDetail', query: {goodsId: item.goodsId, shopId: item.shopId } })
    },
  }
}
</script>

<style lang="less" scoped>
@url: 'https://fileqn.anttalk.vip/';
.list{
  width: 50%;height: 269px;margin: 3px 0;
  &:nth-child(2n-1){
    padding-left: 12px;padding-right: 3px;
  }
  &:nth-child(2n){
    padding-left: 3px;padding-right: 12px;
  }
  .list-item{
    width: 100%;height: 100%;position: relative;z-index: 0;
    background: rgb(175, 29, 30);
    box-shadow: 0 0 4px 1px rgba(29, 29, 28, 0.57);
    border-top-left-radius: 5px;border-top-right-radius: 5px;
    .img-con{
      position: relative;z-index: 0;
      width: 100%;height: 151px;
      padding: 10px 10px 0 11px;
      .img{
        display: block;width: 100%;height: 100%;
        border-top-left-radius: 5px;border-top-right-radius: 5px;
      }
    }
    .top-left{
      position: absolute;z-index: 1;
      width: 12px;height: 12px;top: 10px;left: 11px;
      background: url("@{url}Fl4GKaBd0f9x-Os9n_gH1TuDGEWQ") no-repeat 50% 50%;background-size: 100%;
    }
    .top-right{
      position: absolute;z-index: 1;
      width: 12px;height: 12px;top: 10px;right: 9.5px;
      background: url("@{url}FgMg22eCvCc6eBleOsh_A9gUW11j") no-repeat 50% 50%;background-size: 100%;
    }
    .goods-item-border{
      position: absolute;z-index: 1;top: 0;left: 0;right: 0;bottom: 0;
      padding: 151px 10px 0 11px;
      background: url("@{url}FjAeDphxO2dCOLNjtpCUE63XN_H3") no-repeat 50% 50%;
      background-size: 163px 258.5px;
      .text-con{
        position: relative;
        .list-title{
          margin: 8px 0 14px;
          font-size: 15px;
          font-weight: bold;
          padding: 2px;
          color: #ffefbb;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .btn-con{
          width: 151px;height: 39px;border-radius: 10px;
          display: flex;
          background-image: linear-gradient(rgb(251,233,173), rgb(249,216,127));
          .left{
            width: 63px;height: 100%;
            font-size: 10px;color: #b01f21;
            display: inline-flex;flex-direction: column;
            justify-content: center;align-items: flex-end;
          }
          .right{
            display: inline-flex;justify-content: flex-start;
            align-items: flex-end;
            flex: 1;height: 100%;color: #db0003;
            padding-left: 6px;padding-bottom: 6px;
            .text{
              .big{font-size: 29px;line-height: 1;}
              .small{font-size: 11px;line-height: 1;}
            }
          }

          font-size: 9px;
          color: #999;
          .price{
            padding-right: 10px;
            font-size: 14px;
            color: #f74d4d;
          }
        }
      }
    }
  }
}
</style>